function DeleteConditionModalController() {
  const ctrl = this;

  ctrl.$onInit = () => {
    ctrl.condition = ctrl.resolve.condition;
  };

  ctrl.submit = () => {
    ctrl.close({ $value: ctrl.condition.id });
  };

  ctrl.cancel = () => {
    ctrl.dismiss({ $value: 'cancel' });
  };
}

angular
  .module('pis-tool.module')
  .controller('DeleteConditionModalController', DeleteConditionModalController);
